import { ApiError } from '../errors/api-error.js';

export class SeedPolicyApi {
    constructor(client, basePath = '/seed-policy') {
        this.client = client;
        this.basePath = basePath;
        this.tombstonePath = '/seed-tombstones';
    }

    async get() {
        try {
            const response = await this.client.get(this.basePath);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async update(data) {
        try {
            const response = await this.client.patch(this.basePath, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async listTombstones() {
        try {
            const response = await this.client.get(this.tombstonePath);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async createTombstone(data) {
        try {
            const response = await this.client.post(this.tombstonePath, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async deleteTombstone(id) {
        try {
            const response = await this.client.delete(`${this.tombstonePath}/${id}`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
